import {ActionContext, ActionTree, MutationTree} from 'vuex'
import sdk from '@/lib/sdk'

import {RootState} from '@/store'
import {AxiosResponse} from 'axios'
import {RegistrationRequest} from '@/store/modules/registration'


export class ProfileState {
  public language?: string = undefined
}

const state: ProfileState = {
  language: undefined,
}

const mutations: MutationTree<ProfileState> = {
  PURGE_PROFILE(stateO, payload) {
    stateO.language = undefined
  },
  SET_LANG(stateO, payload: string) {
    stateO.language = payload
  },
}

const actions: ActionTree<ProfileState, any> = {
  purge(store: ActionContext<ProfileState, any>) {
    store.commit('PURGE_PROFILE')
  },
  registration(store: ActionContext<any, any>, payload: RegistrationRequest) {
    return sdk.people.register(payload).then((r: AxiosResponse) => {
      return r.data
    })
  },
  setLang(store: ActionContext<ProfileState, RootState>, payload: string) {
    store.commit('SET_LANG', payload)
    store.dispatch('sleep')
  },
}

export default {
  state,
  mutations,
  actions,
}
